export default __webpack_public_path__ + "static/media/home-icon-bottom-nav-mobile-active.48346b4d.webp";